export default function Marquee({ items }) {
  const sequence = items.map((item, i) => (
    <span key={i} className="flex items-center gap-8 pr-8">
      <span className="font-serif text-2xl sm:text-3xl font-light italic text-brand/80 whitespace-nowrap">
        {item}
      </span>
      <span className="h-1.5 w-1.5 rounded-full bg-brand/40" aria-hidden="true" />
    </span>
  ));
  return (
    <div className="overflow-hidden border-y border-slate-200 bg-brand-linen py-6" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee-scroll">
        <div className="flex items-center">{sequence}</div>
        <div className="flex items-center" aria-hidden="true">{sequence}</div>
      </div>
    </div>
  );
}
